export class Obstruction {

  public id: number;
  public reason: string;
  public startDate: Date;
  public finishDate?: Date;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/obstruction.ts